<button
  class="btn"
  [type]="type()"
  [id]="id()"
  [class]="classes()"
  [class.active]="ariaExpanded() ?? null"
  [disabled]="disabled()"
  [attr.aria-label]="ariaLabel() ?? null"
  [attr.aria-expanded]="ariaExpanded() ?? null"
  [attr.aria-controls]="ariaControls() ?? null"
  [attr.data-cy]="dataCy()"
  (click)="clicked.emit($event)"
>
  <ng-content></ng-content>
</button>
